import React, { useState } from 'react'
import MenuBottom from '../../Component/menuBottom/MenuBottom'
import Shopping from '../Shopping/Shopping'
import WaitingForPay from '../WaitingForPay/WaitingForPay'
import Style from './ShoppingPart.module.css'
const ShoppingPart = () => {
    const [checkedClass,setCheckdClass]=useState(false)
    const ClassHandler =()=>{
        setCheckdClass(false)
    }
    const ClassHandler2 =()=>{
        setCheckdClass(true)
    }
    let Content=null
    if(checkedClass) 
    {
        Content=<WaitingForPay/>
    }
    if(!checkedClass)
    {
        Content=<Shopping/>
    }
    return (
        <div className={Style.PageHolder}>
            <header className={Style.TabsTitle}>
                <div className={checkedClass?Style.normal:Style.checked} onClick={ClassHandler}> سبدخرید </div>
                <div className={checkedClass?Style.checked:Style.normal} onClick={ClassHandler2}> در انتظار پرداخت </div>
            </header>
            {Content}
            <MenuBottom/>

        </div>
    )
}

export default ShoppingPart
